module.exports = __webpack_public_path__ + "media/icons/letter-795ea977.svg";